// 注册中心名称
const apiName = process.env.BUILD_ENV === 'dev' ? 'ec-pc-api' : 'ec-pc-api'
// 套件API
const suite = {

  suitList: {
    type: 'post', // 自定义类型，实际为post
    url: `${apiName}/suite/listSuit`
  }

};

export default suite;
